import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputAdornment, OutlinedInput } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { RADIUS } from '../../../theme/muiTheme';

export default function OfficeToolbar({ value, onChange }) {
  const { t } = useTranslation();

  return (
    <OutlinedInput
      fullWidth
      size="small"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={t('office.searchPlaceholder')}
      inputProps={{ 'aria-label': t('office.searchPlaceholder') }}
      startAdornment={(
        <InputAdornment position="start">
          <SearchIcon fontSize="small" color="disabled" />
        </InputAdornment>
      )}
      sx={{ bgcolor: 'background.paper', borderRadius: `${RADIUS.control}px` }}
    />
  );
}
